import React from 'react';
import cn from 'classnames';

import RouletteMap from 'src/components/YandexMap/components/RouletteMap';
import NoCoordinatesMap from 'src/components/YandexMap/components/NoCoordinatesMap';
import YandexMap from 'src/components/YandexMap';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import HotelLayer from 'src/components/YandexMap/components/HotelLayer';

import Controls from './components/Controls';
import type { YandexHotelMapProps } from './types';
import { HOTEL_MAP_CONTAINER_TEST_ID } from './constants';
import styles from './yandexHotelMap.module.css';

const zoom = 12;

const YMapListener = loadReactComponent('YMapListener', loadModulePromise);

const YandexHotelMap: React.FC<Readonly<YandexHotelMapProps>> = ({
  isRoulette,
  location,
  onExpand,
  isMobile,
  coordinates,
  setIsMapLoading,
  className,
}: YandexHotelMapProps) => {
  // Отслеживаем загрузку тайлов
  // @see https://yandex.ru/dev/jsapi30/doc/ru/dg/concepts/events#handler-interface
  const handleStateChanged = () => {
    setIsMapLoading(false);
  };

  if (isRoulette) {
    setIsMapLoading(false);
    return (
      <RouletteMap
        className={styles.emptyMapContainer}
        isMobile={isMobile}
        location={location}
      />
    );
  }

  if (!coordinates) {
    setIsMapLoading(false);
    return (
      <NoCoordinatesMap
        className={styles.emptyMapContainer}
        isMobile={isMobile}
        location={location}
      />
    );
  }

  return (
    <div
      className={cn(className, styles.container)}
      data-testid={HOTEL_MAP_CONTAINER_TEST_ID}
    >
      <YandexMap isMobile={isMobile} zoom={zoom} center={coordinates}>
        <YMapListener onStateChanged={handleStateChanged} />
        <Controls isMobile={isMobile} onExpand={onExpand} />
        <HotelLayer coordinates={coordinates} />
      </YandexMap>
    </div>
  );
};

export default YandexHotelMap;
